<app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
    [contentTableArray]="contentTableArray" [content_Details]="content_Details"
    (closecontentpopup)="closecontentpopup()" [tablevalues]="tablevalues" [tablekeys]="tablekeys">
</app-contentpopup>
<table class="table table-bordered" id="excel-table">
    <div class="table-responsive">
        <thead *ngIf="!this.paramsValues.section">
            <tr>
                <th *ngIf="showCheckBox" style="text-align: center;">Select</th>
                <th></th>
                <th>
                    <i class="fa fa-edit icons" (click)="editbtn()"></i>
                    <i class="fa fa-download icons" title="Dowload file" (click)="downloadFiles()"></i>
                    <i class="fa fa-check-square icons" title="Download upon selection"
                        (click)="downloadSelected()"></i>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let Obj of DragData | Object2keyvalue; let index=index"
                [ngStyle]="{'display': Obj.key ==='colorindicator' ?'none' : ' ' }">
                <td *ngIf="showCheckBox"><input type="checkbox" style="margin-left: 2.5rem;"
                        (click)="selected_checbox(Obj.key, index)" /></td>
                <td #headerids [ngStyle]="{'display': Obj.key ==='colorindicator' ?'none' : ' ' }"
                    [ngClass]="[getcolorcode(Obj.key,DragData.colorindicator), Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key === 'Food effect' || Obj.key === 'Indications and Usage'||Obj.key === 'Variability (% ISCV)'||Obj.key === 'PK Linearity'|| Obj.key === 'Pharmacology'? 'underline': '']"
                    (click)="addClickEvent($event,Obj.value,Obj.key)">
                    {{Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key === 'Food
                    effect' || Obj.key === 'Indications and Usage'||Obj.key === 'Variability (% ISCV)'||Obj.key === 'PK
                    Linearity' || Obj.key === 'Pharmacology'? Obj.key + '*':Obj.key}}
                </td>
                <td>
                    <div *ngIf="Obj.value | arrayChk;else displayvalue;let is=index">
                        <div *ngIf="Obj.value | tableChk;else list">
                            <div class="table-responsive">
                                <table class="table table-bordered" id="innertable">
                                    <thead style="font-size: 12px;">
                                        <tr>
                                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader">
                                                <p>{{headers}}</p>
                                                <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody style="font-size: 10px;">
                                        <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                                            <td *ngFor="let rdata of trows;let iindex =index">
                                                <!-- <p [ngClass]="[showedit?'editcls':'editdisable']">
                                                    <input type="text"
                                                        (change)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                                        [ngClass]="[rdata.length>=20?'input-size':'']" value={{rdata}}
                                                        id={{rdata}} />
                                                </p> -->
                                                <p
                                                    [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']">
                                                    {{Obj.key === 'Dosage and Administration' || Obj.key ===
                                                    'Recommended dose' || Obj.key === 'Food effect' || Obj.key ===
                                                    'Indications and Usage' ||Obj.key === 'Variability (%
                                                    ISCV)'||Obj.key === 'PK Linearity'||Obj.key === 'Pharmacology'? '':
                                                    rdata}}
                                                </p>
                                            </td>
                                        </tr>

                                        <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                                            class="fas fa-plus float-left"
                                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)"></i>
                                        <button
                                            [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                                            *ngIf="Obj.value.length>sliceEnd" class="btn btn-success"
                                            (click)="showLess(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                                            More</button>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <ng-template #list>
                            <ul>

                                <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index"
                                    [ngClass]="[Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key === 'Food effect' || Obj.key === 'Indications and Usage'||Obj.key === 'Variability (% ISCV)'||Obj.key === 'PK Linearity'||Obj.key ==='Pharmacology'?'list-style-none ':'list-style-type']">
                                    <p [ngClass]="[showedit?'editcls':'editdisable']">
                                        <!-- <input type="text" [ngClass]="[lItems.length>=20?'input-size':'']" (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" value={{lItems}} /> -->
                                        <!-- <textarea [ngClass]="[lItems.length>=20?'input-size':'']"
                                            (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')"
                                            style="height: 30px;" value={{lItems}} cols="30" rows="10"></textarea> -->
                                    </p>
                                    <p [ngClass]="[!showedit?'editcls':'editdisable']">

                                        {{Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' ||
                                        Obj.key === 'Food effect' || Obj.key === 'Indications and Usage'||Obj.key ===
                                        'Variability (% ISCV)'||Obj.key === 'PK Linearity' || Obj.key ===
                                        'Pharmacology'? '': lItems}}

                                    </p>

                                </li>
                                <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                                    class="fas fa-plus float-left"
                                    (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key)"></i>
                                <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                                    *ngIf="Obj.key !== 'Dosage and Administration' && Obj.key !== 'Recommended dose' &&  Obj.key !== 'Indications and Usage' && Obj.value.length>5"
                                    class="btn btn-success"
                                    (click)="showArray(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                                    More</button>

                            </ul>
                        </ng-template>
                    </div>
                    <ng-template #displayvalue>
                        <!-- <p
                            [ngClass]="[showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                            <input type="text" [ngClass]="[Obj.value?.length>=20?'input-size':'']" value={{Obj.value}}
                                (change)="editdata($event,Obj.value,Obj.key,index,'')" />
                        </p> -->
                        <p [ngClass]="[!showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']"
                            (click)="addClickEvent($event,Obj.value,Obj.key)">
                            {{Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key ===
                            'Food effect' || Obj.key === 'Indications and Usage'||Obj.key === 'Variability (%
                            ISCV)'||Obj.key === 'PK Linearity' ||Obj.key === 'Pharmacology' ? '': Obj.value}}

                        </p>

                        <i [ngClass]="[ Obj.key ==='FDA label' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                            (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
                        <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                            (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
                        <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div>
                        <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div>
                    </ng-template>

                    <div *ngFor="let edited of isChanged(Obj.key)">
                        <div *ngIf="edited === Obj.key" [id]="Obj.key">
                            <i class="fa fa-check" title="Accept" (click)="handelAction(Obj,'accept')"
                                style="cursor: pointer;color:#2bc44e;padding-left:1rem;"></i>
                            <i class="fa fa-remove" title="Reject" (click)="handelAction(Obj,'reject')"
                                style="cursor: pointer;padding-left:3rem;color:red"></i>
                        </div>
                    </div>

                </td>

            </tr>
            <tr>
                <td *ngIf="showCheckBox">
                    <button class="btn btn-primary" (click)="downloadSelectedData()">Download</button>
                </td>
            </tr>
        </tbody>
    </div>
</table>
<div *ngIf="showedit" class="text-center">
    <button class="btn btn-primary" (click)="saveEdit()">Save</button>
</div>